module.exports = __webpack_public_path__ + "static/media/web-dev-good-programming-habit-of-using-full-stack-application.133f84df.jpg";